<po-page-default p-title="Relatório de convênio médico" [p-breadcrumb]="breadcrumb">
  <div class="po-row">
    <po-container class="po-lg-12 po-md-12 po-sm-12">
      <span class="po-font-text-uppercase titulo">
        <span class="an an-heartbeat"></span>
        Relatório de convênio médico
      </span>

      <p class="po-mt-2">
        Envie o PDF da Amil. Assim que o processamento terminar, baixam o zip com uma planilha por funcionário e a planilha de resumo do RH.
      </p>

      <div class="po-lg-12 po-mt-2">
        <po-upload
          #uploadPdf
          [p-restrictions]="pdfRestrictions"
          p-size="medium"
          [p-drag-drop]="true"
          [p-multiple]="false"
          [p-drag-drop-height]="150"
          [p-url]="urlPlaceholder"
          [p-hide-send-button]="true"
          [p-disabled]="enviando"
          p-label="PDF da Amil">
        </po-upload>
      </div>

      <po-button
        class="po-lg-4 po-mt-3"
        p-icon="an an-download"
        p-label="Gerar relatórios"
        (p-click)="gerar()"
        [p-loading]="enviando"
        [p-disabled]="enviando">
      </po-button>
    </po-container>
  </div>
</po-page-default>
